function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 6L7 2V10L2 6Z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 2H7.5C7.5 1.8078 7.38983 1.63261 7.21659 1.54935C7.04336 1.46609 6.83774 1.4895 6.68765 1.60957L7 2ZM2 6L1.68765 5.60957C1.56904 5.70445 1.5 5.84811 1.5 6C1.5 6.15189 1.56904 6.29555 1.68765 6.39043L2 6ZM7 10L6.68765 10.3904C6.83774 10.5105 7.04336 10.5339 7.21659 10.4507C7.38983 10.3674 7.5 10.1922 7.5 10H7ZM6.68765 1.60957L1.68765 5.60957L2.31235 6.39043L7.31235 2.39043L6.68765 1.60957ZM1.68765 6.39043L6.68765 10.3904L7.31235 9.60957L2.31235 5.60957L1.68765 6.39043ZM7.5 10V2H6.5V10H7.5Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.96774 20C8.41546 20 7.96774 20.4477 7.96774 21C7.96774 21.5523 8.41546 22 8.96774 22V20ZM7.5 7H15.5V5H7.5V7ZM15.5 20H8.96774V22H15.5V20ZM22 13.5C22 17.0899 19.0899 20 15.5 20V22C20.1944 22 24 18.1944 24 13.5H22ZM24 13.5C24 8.80558 20.1944 5 15.5 5V7C19.0899 7 22 9.91015 22 13.5H24Z"
});

function SvgUndo(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather feather-undo",
    ref: svgRef
  }, props), _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.43c8a3ff.svg";
export { ForwardRef as ReactComponent };